// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-form-toggle-area {\n    border-top: 1px solid var(--gray-300);\n}\n\n.product-available-form-area .form-group {\n    margin-bottom: 0;\n    margin-top: 0!important;\n}\n\n#product-available-current {\n    display: flex;\n    align-self: center;\n}\n\n#product-available-current > span {\n    padding: 0.375rem 0.75rem;\n    border: 1px solid transparent;\n}\n\n.product-available-form-area .row.form-group {\n    margin-right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
